<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path fill-rule="evenodd" d="M38.813 24c0 8.18-6.632 14.813-14.813 14.813-8.18 0-14.813-6.632-14.813-14.813C9.188 15.82 15.82 9.187 24 9.187S38.813 15.819 38.813 24zm-16.376 4.88h-2.286v-2.27H15.5v-1.93l2.69-6.61h2.536l-2.613 6.47h2.038v-2.333h2.286v2.334h1.151v2.068h-1.15v2.271zm10.032-8.255l-2.812 3.919 2.767 4.143h-2.747l-1.427-2.146-1.312 2.146h-2.625l2.68-4.006-2.669-4.056h2.747l1.391 2.102 1.392-2.102h2.615z"/></svg>